import(/* webpackMode: "eager" */ "/codebuild/output/src626159113/src/next-app/app/global-error.tsx");
